// GA Data handling - Check Expiry and Clear if Expired
export const checkGADataExpiry = () => {
	const expiry = localStorage.getItem('cc-gclId-expiry');
	if (expiry && Date.now() > parseInt(expiry, 10)) {
		localStorage.removeItem('cc-gclId');
		localStorage.removeItem('cc-gclId-expiry');
	}
};
